export default function Home() {
  return (
    <header className="sticky top-0 z-50 w-full border-b border-glass-border bg-black/20 backdrop-blur-md">
      <div className="container mx-auto flex h-14 items-center justify-between px-4 max-w-lg">
        <div className="flex items-center gap-3">
          <div className="relative w-8 h-8 rounded-lg overflow-hidden border border-white/10 shadow-neon">
            <img src="/icon.png" alt="BaseVibe" className="w-full h-full object-cover" />
          </div>
          <h1 className="text-lg font-bold text-white tracking-wide">BaseVibe</h1>
        </div>
      </div>
    </header>
  )
}

